<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'gestoesDeAulas.planosInfantilBimestrais' })"
            :id="'btn-voltar-planos'"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Plano Bimestral Infantil
        </h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-btn
          depressed
          color="primary"
          @click="() => [visualizarPdf(plano.id), (dialogPdf = true)]"
          :id="'btn-visualizar-pdf'"
        >
          Visualizar Pdf
          <v-icon small right> mdi-note </v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" sm="10" md="12" lg="12">
        <v-card>
          <v-card-text>
            <label for="">Professor</label>
            <v-input :id="'input-professor'">
              {{
                plano.gestao_de_aula
                  ? plano.gestao_de_aula.professor
                    ? plano.gestao_de_aula.professor.nome
                    : "- - -"
                  : "- - - "
              }}
            </v-input>

            <label for="">Turma</label>
            <v-input :id="'input-turma'">
              {{
                plano.gestao_de_aula
                  ? plano.gestao_de_aula.turma
                    ? plano.gestao_de_aula.turma.descricao
                    : "- - -"
                  : "- - - "
              }}
            </v-input>

            <label for="">Disciplina</label>
            <v-input :id="'input-disciplina'">
              {{
                plano.gestao_de_aula
                  ? plano.gestao_de_aula.disciplina
                    ? plano.gestao_de_aula.disciplina.descricao
                    : "- - - "
                  : "- - - "
              }}
            </v-input>

            <label for="">Bimestre de Referência</label>
            <v-input :id="'input-bimestre-referencia'">
              <v-chip>
                {{ plano.bimestre?.descricao ?? "- - - " }}
              </v-chip>
            </v-input>

            <label for="">Data lançamento</label>
            <v-input :id="'input-data-lancamento'">
              <v-chip>
                {{
                  plano.created_at
                    ? plano.created_at.substr(0, 10).split("-").reverse().join("/")
                    : "- - - "
                }}
              </v-chip>
            </v-input>

            <label for="">Ultima atualização</label>
            <v-input :id="'input-ultima-atualizacao'">
              <v-chip>
                {{
                  plano.updated_at
                    ? plano.updated_at.substr(0, 10).split("-").reverse().join("/")
                    : "- - - "
                }}
              </v-chip>
            </v-input>
            <v-combobox
              v-model="seriesSelecionadas"
              chips
              label="Series"
              multiple
              readonly
              :id="'combobox-series'"
            />
          </v-card-text>
        </v-card>

        <v-card class="mt-5">
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="4">
                <label for="">Status</label>
                <e-situacao-plano-infantil
                  :plano="plano"
                  v-on:update="listarPlano"
                  :id="'situacao-plano'"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col :id="'col-objetivos-aprendizagem'">
                <v-divider></v-divider>
                <label>Objetivos de aprendizagem e desenvolvimento </label>
                <v-list-item v-for="(objetivo, i) in objetivosSelecionados" :key="i">
                  <li>
                    {{ objetivo ? objetivo.descricao : "- - -" }}
                  </li>
                </v-list-item>
              </v-col>
            </v-row>

            <v-row>
              <v-col :id="'col-campos-experiencia'">
                <v-divider></v-divider>
                <label>Campos de experiência </label>
                <v-list-item v-for="(experiencia, i) in experienciasSelecionadas" :key="i">
                  <li>
                    {{ experiencia ? experiencia : "- - -" }}
                  </li>
                </v-list-item>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>
                <label for="">OBJETIVOS ESPECÍFICOS</label>
                <v-textarea
                  filled
                  rounded
                  dense
                  color="primary"
                  readonly
                  auto-grow
                  :value="objetivosFormatados"
                  :id="'textarea-objetivos-especificos'"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-divider></v-divider>
                <label for="">OBJETIVOS ESPECÍFICOS - DESCRIÇÃO</label>
                <v-textarea
                  filled
                  rounded
                  dense
                  color="primary"
                  readonly
                  auto-grow
                  :value="plano.observacao ? plano.observacao : '- - - '"
                  :id="'textarea-objetivos-especificos-descricao'"
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>

                <label for="">OBJETIVO GERAL</label>
                <v-textarea
                  filled
                  rounded
                  dense
                  color="primary"
                  readonly
                  auto-grow
                  :value="plano.objetivo_geral ? plano.objetivo_geral : '- - - '"
                  :id="'textarea-objetivo-geral'"
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>
                <label for="">SABERES E CONHECIMENTOS</label>
                <v-textarea
                  filled
                  rounded
                  dense
                  color="primary"
                  readonly
                  auto-grow
                  :value="plano.saberes_conhecimentos ? plano.saberes_conhecimentos : '- - -'"
                  :id="'textarea-saberes-conhecimentos'"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-divider></v-divider>
                <label for="">ATIVIDADES/METODOLOGIA</label>
                <v-textarea
                  filled
                  rounded
                  dense
                  color="primary"
                  readonly
                  auto-grow
                  :value="plano.metodologia ? plano.metodologia : '- - -'"
                  :id="'textarea-atividades-metodologia'"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-divider></v-divider>
                <label for="">AVALIAÇÃO</label>
                <v-textarea
                  filled
                  rounded
                  dense
                  color="primary"
                  readonly
                  auto-grow
                  :value="plano.avaliacao ? plano.avaliacao : '- - -'"
                  :id="'textarea-avaliacao'"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-divider></v-divider>
                <label for="">AVALIAÇÃO</label>
                <v-textarea
                  filled
                  rounded
                  dense
                  color="primary"
                  readonly
                  auto-grow
                  :value="plano.avaliacao ? plano.avaliacao : '- - -'"
                  :id="'textarea-avaliacao'"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-divider></v-divider>
                <label for="">RECURSOS</label>
                <v-textarea
                  filled
                  rounded
                  dense
                  color="primary"
                  readonly
                  auto-grow
                  :value="plano.recursos ? plano.recursos : '- - -'"
                  :id="'textarea-recursos'"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <ModalCarteira :dialog="dialogPdf" :pdf="pdf" @update="fecharModal" />
  </main-template>
</template>

<script>
import ModalCarteira from "@/components/Matriculas/EModalCarteira.vue";

export default {
  components: {
    ModalCarteira,
  },
  data() {
    return {
      dialogPdf: false,
      pdf: null,
      showSnackbar: false,
      plano: {},
      plano_id: null,
      seriesSelecionadas: [],
      experienciasSelecionadas: [],
      objetivosSelecionados: [],
      recursosSelecionados: [],
      duvidasSelecionadas: [],
      objetivos_especificos: [
        { model: "terra_pedras", label: "BRINCADEIRA COM TERRA E PEDRAS", color: "orange" },
        { model: "jardim_sensorial", label: "JARDIM SENSORIAL", color: "orange" },
        {
          model: "cordajardim_sensorial",
          label: "BRINCADEIRA COM CORDA",
          color: "orange",
        },
        {
          model: "coelho_curioso",
          label: "AVENTURA NA FLORESTA COM COELHINHO CURIOSA",
          color: "orange",
        },
        { model: "bamboloes", label: "BRINCADEIRAS COM BAMBOLÊS", color: "orange" },
      ],
    };
  },
  async mounted() {
    this.getId();
    this.listarPlano(this.pageNumber);
  },
  computed: {
    objetivosFormatados() {
      if (!this.plano?.objetivos_especificos) return "- - -";

      let modelos = [];

      try {
        // Tenta transformar em array se for string
        modelos =
          typeof this.plano.objetivos_especificos === "string"
            ? JSON.parse(this.plano.objetivos_especificos)
            : this.plano.objetivos_especificos;
      } catch (e) {
        return "- - -";
      }

      const TODOS_OBJETIVOS = [
        { model: "terra_pedras", label: "BRINCADEIRA COM TERRA E PEDRAS", color: "orange" },
        { model: "jardim_sensorial", label: "JARDIM SENSORIAL", color: "orange" },
        { model: "cordajardim_sensorial", label: "BRINCADEIRA COM CORDA", color: "orange" },
        {
          model: "coelho_curioso",
          label: "AVENTURA NA FLORESTA COM COELHINHO CURIOSA",
          color: "orange",
        },
        { model: "bamboloes", label: "BRINCADEIRAS COM BAMBOLÊS", color: "orange" },
      ];

      const labels = modelos.map((model) => {
        const objetivo = TODOS_OBJETIVOS.find((o) => o.model === model);
        return objetivo ? `• ${objetivo.label}` : `• ${model}`;
      });

      return labels.join("\n");
    },
  },
  methods: {
    async getId() {
      const { id } = this.$route.params;
      this.plano_id = id;
    },
    async listarPlano() {
      this.$loaderService.open("Carregando Plano");
      try {
        const { data } = await this.$services.planosService.showBimestralInfantil(this.plano_id);

        this.plano = { ...data.planoBimestralInfantil };
        this.seriesSelecionadas = this.plano.gestao_de_aula.turma.series.map((s) => s.descricao);

        this.objetivosSelecionados = [...data.objeto_aprendizagem];
        this.experienciasSelecionadas = [...data.planoBimestralInfantil.experiencia];
      } catch (error) {
        this.$loaderService.close();
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async carregarDadosAoAtualizarStatus() {
      try {
        this.listarPlano();
      } catch (error) {
        this.$handleError(error);
      }
    },
    async visualizarPdf(planoId) {
      this.pdf = await this.$services.planosService.pdfInfantil(planoId);
    },
    fecharModal() {
      this.pdf = null;
      this.dialogPdf = false;
    },
  },
};
</script>

<style></style>
